import { ORDER_COMPLETED } from '@constant/order';
import { disableLoader, enableLoader, showError } from '@context/actions';
import { Backdrop } from '@material-ui/core';
import OrderBillPrintModal from '@module/orderBillPrintModal';
import OrderDetailModel from '@module/orderDetailModal';
import { getOrderByTenantIdAndGuestId } from '@storeData/order';
import { formatTimeTo12Hr, formatToDateFormat } from '@util/utils';
import { useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { CloseIcon, IconFrame } from '@element/icons';


function OrderHistoryPage() {
    const dispatch = useDispatch();
    const [cookie, setCookie] = useCookies();
    const [userData, setUserCookie] = useState(cookie['user']);
    const store = useSelector((state: any) => state);
    const [orderHistoryData, setOrderHistoryData] = useState(null);
    const [activeOrder, setactiveOrder] = useState(null);
    const [activeModal, setActiveModal] = useState(null);
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const languageData: any = store.languageKeywords
    useEffect(() => {
        dispatch(enableLoader());
        getOrderByTenantIdAndGuestId(userData.id, userData.tenantId)
            .then((order: any) => {
                if (order) {
                    // order = order.filter((o) => !o.appointmentId);
                    order.sort(function (a: any, b: any) {
                        var dateA: any = new Date(a.orderDay).getTime();
                        var dateB: any = new Date(b.orderDay).getTime();
                        return dateA < dateB ? 1 : -1; // ? -1 : 1 for ascending/increasing order
                    });
                    setOrderHistoryData(order);
                    dispatch(disableLoader());
                }
            })
            .catch((e) => {
                dispatch(disableLoader());
                dispatch(showError(e.error));
            })
    }, [])

    const closeModal = () => {
        setActiveModal(null);
        setactiveOrder(null);
    }

    return (
        <>
            {orderHistoryData ?
                <div className="order-history-outer">
                    <p className="heading">{languageData["Order History"] ? languageData["Order History"] : "Order History"}</p>
                    {orderHistoryData.length ? <div className='card'>
                        {orderHistoryData?.map((item, index) => {
                            return <div className="order-card" key={Math.random()} onClick={() => setactiveOrder(item)}>
                                <span>{languageData["order"] ? languageData["order"] : "order"} #{item.orderId}</span><span className="order-type">{`(${item.statuses[item.statuses.length - 1].state})`}</span>
                                <span className="right-align">{configData.currencySymbol} {item.total}</span>
                                <div>
                                    <span className="order-type">{item.type}</span>
                                    <span className="right-align order-type color">
                                        {formatToDateFormat(item.orderDay, configData.dateFormat)} {formatTimeTo12Hr(`${new Date(item.createdOn).getHours()}:${new Date(item.createdOn).getMinutes()}`)}</span>
                                </div>
                                <div>
                                    <span className="action-button" onClick={(e) => { e.stopPropagation(); setactiveOrder(item); setActiveModal('details') }}>{languageData["View Details"] ? languageData["View Details"] : "View Details"}</span>
                                    {item.statuses[item?.statuses?.length - 1]?.state == ORDER_COMPLETED && <span className="action-button" onClick={(e) => { e.stopPropagation(); setactiveOrder(item); setActiveModal('bill') }}>{languageData["View Bill"] ? languageData["View Bill"] : "View Bill"}</span>}
                                </div>
                            </div>
                        })}
                    </div> : <div className="order-history-outer">
                        <div className="sub-heading"> {languageData["You do not have any Order"] ? languageData["You do not have any Order"] : "You do not have any Order"}</div>
                    </div>}
                    {activeOrder && activeModal === 'details' &&
                        <OrderDetailModel orderData={activeOrder} openModal={activeModal === 'details'} handleClose={() => closeModal()} />
                    }
                    {activeOrder && activeModal === 'bill' && activeOrder.statuses[activeOrder?.statuses?.length - 1]?.state == ORDER_COMPLETED &&
                        <Backdrop
                            className="backdrop-modal-wrapper ordrer-backdrop-modal-wrapper"
                            open={activeModal === 'bill'}
                            style={{ zIndex: 20 }}
                        >
                            <div className="backdrop-modal-content" style={{ height: '100vh' }}>
                                <div className="heading" >{languageData["Order Bill"] ? languageData["Order Bill"] : "Order Bill"}</div>
                                <div className="modal-close" onClick={() => closeModal()}>
                                    <IconFrame><CloseIcon /></IconFrame>
                                </div>
                                <div className='pricing-details-wrap' style={{ height: 'calc(100vh - 60px)' }}>
                                    <OrderBillPrintModal orderData={activeOrder} />
                                </div>
                            </div>
                        </Backdrop>
                    }
                </div> :
                <div className='orders-unavailable d-f-c'>
                    {languageData["Orders Unavailable"] ? languageData["Orders Unavailable"] : "Orders Unavailable"}
                </div>}
        </>
    )
}

export default OrderHistoryPage;
